namespace $ {
	export class $visavis_discovery extends $visavis_plot_plotly {
		
		/**
		 * ```tree
		 * pages /
		 * 	<= Plot
		 * 	<= Setup
		 * ```
		 */
		pages() {
			return [
				this.Plot(),
				this.Setup()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * elemental_checked*? false
		 * ```
		 */
		@ $mol_mem_key
		elemental_checked(id: any, next?: any) {
			if ( next !== undefined ) return next as never
			return false
		}
		
		/**
		 * ```tree
		 * elementals_dict *
		 * ```
		 */
		elementals_dict() {
			return {
			} as Record< string, any >
		}
		
		/**
		 * ```tree
		 * Elementals_check $mol_check_list
		 * 	option_checked*? <=> elemental_checked*?
		 * 	options <= elementals_dict
		 * ```
		 */
		@ $mol_mem
		Elementals_check() {
			const obj = new this.$.$mol_check_list()
			
			obj.option_checked = (id: any, next?: any) => this.elemental_checked(id, next)
			obj.options = () => this.elementals_dict()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Elementals $mol_labeler
		 * 	title \Elementals on
		 * 	Content <= Elementals_check
		 * ```
		 */
		@ $mol_mem
		Elementals() {
			const obj = new this.$.$mol_labeler()
			
			obj.title = () => "Elementals on"
			obj.Content = () => this.Elementals_check()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Setup $mol_page
		 * 	title @ \Setup
		 * 	body / <= Elementals
		 * ```
		 */
		@ $mol_mem
		Setup() {
			const obj = new this.$.$mol_page()
			
			obj.title = () => this.$.$mol_locale.text( '$visavis_discovery_Setup_title' )
			obj.body = () => [
				this.Elementals()
			] as readonly any[]
			
			return obj
		}
	}
	
}

